// extracted by mini-css-extract-plugin
export var label = "_j1-2";
export var slideContainer = "_j1-0";
export var slider = "_j1-1";